import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper
} from '@mui/material';
import { Link } from 'react-router-dom';

const CoachesInvitePage = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50', py: { xs: 4, md: 6 } }}>
      <Container maxWidth="md">
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            mb: 4,
            textAlign: 'center',
            color: 'primary.main'
          }}
        >
          Kviečiame trenerius prisijungti
        </Typography>

        <Paper sx={{ p: { xs: 3, md: 5 }, mb: 4 }}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Kviečiame trenerius prisijungti į internetinių rezervacijų sistemą.
          </Typography>

          <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
            TenisoUžsiėmimai.lt privalumai:
          </Typography>

          <Box component="ul" sx={{ pl: 3, mb: 3 }}>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Sumažinamas administracinis rūpestis. Klientai rezervuoja treniruotes įvesdami visą reikalingą informaciją. Jeigu rezervacija atliekama be aikštelės - Jums tenka pasirūpinti ja. Aikštelei neatsiradus - galima atšaukti su automatiniu pranešimu klientui.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Nemokamai. Naudokitės šiuo administravimo įrankiu be jokių išlaidų.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Patogu žymėti savo laisvus laikus internetinėje svetainėje, arba mobilioje programėlėje.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Pasirinkite savo norimus įkainius už treniruotes 1,2,3 ar 4 žmonėms.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              El. paštu gausite informaciją apie kiekvieną rezervaciją - kada, kur ir kiek žmonių ateis. Taip pat automatinio pridėjimo prie kalendoriaus nuorodą.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Kiekvienas treneris turi savo unikalų URL, todėl galite jį įtraukti į savo reklamas (jei to norite).
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Per internetinę rezervacijų sistemą treniruotės atšaukti negalima likus mažiau nei 60 valandų. Jei klientas nori atšaukti treniruotę likus mažiau nei 60 valandų - jam nurodoma kreiptis trenerio telefono numeriu. Čia galite taikyti savo atšaukimo politiką.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Kitos dienos rezervacijos rytiniams laikams (7:00–11:00) užsidaro 22:00 Lietuvos laiku.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              Tos pačios dienos rezervacijos gali būti atliktos ne vėliau kaip 3 valandas prieš pageidaujamą laiką.
            </Typography>
            <Typography component="li" variant="body1" sx={{ mb: 2 }}>
              iOS ir Android programėlės patogesniam trenerių darbui (klientams kol kas prieigos nėra).
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mt: 2 }}>
            <Button
              component={Link}
              to="/coachregistrationform"
              variant="contained"
              color="success"
              size="large"
              fullWidth
              sx={{ py: 1.5, borderRadius: 2, fontWeight: 600 }}
            >
              Registruotis
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default CoachesInvitePage;
